import { defineMessages } from '@jutro/locale';

export default defineMessages({
    PeopleInvolved: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.People Involved',
        defaultMessage: 'People Involved'
    },
    driver: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.DRIVER',
        defaultMessage: 'DRIVER'
    },
    license: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.License:',
        defaultMessage: 'License: {license}'
    },
    phone: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.Phone',
        defaultMessage: 'Phone:'
    },
    yourPassengers: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.YOUR PASSENGERS',
        defaultMessage: 'YOUR PASSENGERS'
    },
    otherDriver: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.OTHER DRIVER',
        defaultMessage: 'OTHER DRIVER'
    },
    otherVehiclePassenger: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.OTHER VEHICLE PASSENGERS',
        defaultMessage: 'OTHER VEHICLE PASSENGERS'
    },
    claimant: {
        id: 'ml.gateway.views.AccountClaims.PeopleInvolved.CLAIMANT',
        defaultMessage: 'CLAIMANT'
    }

});
